import classNames from 'classnames'
import { observer } from 'mobx-react'
import { useEffect, useRef, useState } from 'react'
import './index.scss'
import { ReactComponent as Arrow } from '../../../../assets/login/Rectangle 30.svg'
import IMask from 'imask'
import CountrySelect from '../../login/CountrySelect'
import { updateOld } from '../../../../stores/UserModel'
import ContentState from '../../../../stores/ContentState'
import GlobalState from '../../../../stores/GlobalState'

const Personal = observer(
  ({ setStep, email }: { setStep: () => void; email: string }) => {
    const inputRef = useRef<any>(null)
    const [show, setShow] = useState(false)
    const [showPhones, setShowPhones] = useState(false)
    const [showCode, setShowCode] = useState(false)
    const [state, setState] = useState({
      name: '',
      lastname: '',
      country: '',
      phone: '',
      code: '',
    })
    const [errs, setErrs] = useState({
      name: '',
      lastname: '',
      phone: '',
      country: '',
    })

    useEffect(() => {
      if (!inputRef.current) return
      const maskOptions = {
        mask: '00-000-00-00',
      }
      const mask = IMask(inputRef.current, maskOptions)

      return () => {
        mask.destroy()
      }
    }, [state.code, state.phone])

    const checkText = (str: string) => {
      return /([^0-9])$/.test(str)
    }

    const submit = () => {
      const errs = {
        name: !state.name.length
          ? `${content.nameText} ${content.emptyError}`
          : '',
        lastname: !state.lastname.length
          ? `${content.lastNameText} ${content.emptyError}`
          : '',
        country: !state.country.length ? content.chooseCountry : '',
        phone: !state.phone.length
          ? `${content.phoneText} ${content.emptyError}`
          : '',
      }

      if (
        errs.name.length ||
        errs.lastname.length ||
        errs.country.length ||
        errs.phone.length
      ) {
        setErrs(errs)
        return
      }
      const code = state.code.replaceAll('+', '')
      const phone = state.phone.replaceAll('-', '')

      updateOld(
        email,
        state.name,
        state.lastname,
        `${code}${phone}`,
        state.country,
      ).then(() => {
        let lang = GlobalState.currentLocale.lang.includes('En')
          ? '/en'
          : GlobalState.currentLocale.lang.includes('ру')
          ? '/ru'
          : ''
        window.location.href = `${lang}/account`
      })
    }

    useEffect(() => {
      if (state.name.length) {
        setErrs({ ...errs, name: '' })
      }
    }, [state.name])
    useEffect(() => {
      if (state.lastname.length) {
        setErrs({ ...errs, lastname: '' })
      }
    }, [state.lastname])
    useEffect(() => {
      if (state.country.length) {
        setErrs({ ...errs, country: '' })
      }
    }, [state.country])

    useEffect(() => {
      if (state.phone.length) {
        setErrs({ ...errs, phone: '' })
      }
    }, [state.phone])

    if (!ContentState.registr?.personal) return <></>

    const content = ContentState.registr?.personal

    return (
      <section className="personal2">
        {!showPhones ? (
          <>
            <div className="login-content2__title">{content.title}</div>
            <div className="login-content2__slim-text">{content.mainText}</div>
            <div
              className={classNames(
                'login-content2__input',
                errs.name.length && 'error',
                state.name.length && 'fill',
              )}
            >
              <input
                placeholder={`${content.nameText} *`}
                className="input"
                onChange={(e) => {
                  if (!e.target.value.length) {
                    setState({ ...state, name: e.target.value })
                    return
                  }
                  if (checkText(e.target.value)) {
                    setState({ ...state, name: e.target.value })
                  }
                }}
                value={state.name}
              />
            </div>
            <div
              className={classNames(
                'login-content2__input',
                errs.lastname.length && 'error',
                state.lastname.length && 'fill',
              )}
            >
              <input
                placeholder={`${content.lastNameText} *`}
                className="input"
                onChange={(e) => {
                  if (!e.target.value.length) {
                    setState({ ...state, lastname: e.target.value })
                    return
                  }
                  if (checkText(e.target.value)) {
                    setState({ ...state, lastname: e.target.value })
                  }
                }}
                value={state.lastname}
              />
            </div>
            <div
              className={classNames(
                'login-content2__input cursor choose-country',
                errs.country.length && 'error',
                state.country.length && 'fill',
              )}
              onClick={() => {
                setShow(true)
                setShowCode(false)
              }}
            >
              {!show ? (
                <>
                  <input
                    placeholder={`${content.chooseCountry} *`}
                    className="input"
                    readOnly={true}
                    value={state.country}
                  />
                  <Arrow />
                </>
              ) : (
                <>
                  <CountrySelect
                    showCode={showCode}
                    setState={(value) => {
                      if (!value) {
                        setShow(false)
                        return
                      }
                      if (showCode) {
                        setState({ ...state, code: value.number })
                      } else {
                        setState({
                          ...state,
                          country: value.country,
                          code: value.number,
                        })
                      }
                      setShow(false)
                    }}
                  />
                </>
              )}
            </div>
            <div className="personal2__row">
              <div
                className={classNames(
                  'login-content2__input cursor',
                  errs.phone.length && 'error',
                  state.phone.length && 'fill',
                )}
                onClick={() => {
                  setShowPhones(true)
                  setShowCode(true)
                }}
              >
                <input
                  placeholder="+380"
                  className="input"
                  readOnly={true}
                  value={state.code}
                />
                <Arrow />
              </div>
              <div
                className={classNames(
                  'login-content2__input',
                  errs.phone.length && 'error',
                  state.phone.length && 'fill',
                )}
              >
                <input
                  ref={inputRef}
                  placeholder={`${content.phoneText} *`}
                  className="input"
                  onChange={(e) =>
                    setState({ ...state, phone: e.target.value })
                  }
                  value={state.phone}
                />
              </div>
            </div>
            {errs.name.length ? (
              <div className="login-content2__error">{errs.name}</div>
            ) : (
              <></>
            )}
            {errs.lastname.length ? (
              <div className="login-content2__error">{errs.lastname}</div>
            ) : (
              <></>
            )}
            {errs.country.length ? (
              <div className="login-content2__error">{errs.country}</div>
            ) : (
              <></>
            )}
            {errs.phone.length ? (
              <div className="login-content2__error">{errs.phone}</div>
            ) : (
              <></>
            )}
            <p
              className={classNames('login-content2__text', 'reg')}
              dangerouslySetInnerHTML={{ __html: content.text }}
            ></p>

            <div className="button black" onClick={submit}>
              {content.butReg}
            </div>

            <div className="button grey-border" onClick={setStep}>
              {content.exitBut}
            </div>
          </>
        ) : (
          <CountrySelect
            showCode={true}
            setState={(value) => {
              if (!value) {
                setShowPhones(false)
                return
              }
              if (showCode) {
                setState({ ...state, code: value.number })
                setShowPhones(false)
              } else {
                setState({
                  ...state,
                  country: value.country,
                  code: value.number,
                })
              }
              setShowPhones(false)
            }}
          />
        )}
      </section>
    )
  },
)

export default Personal
